import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, unref as _unref } from "vue"

const _hoisted_1 = { ref: "showbtn" }
const _hoisted_2 = { class: "selected-items mt-2" }
const _hoisted_3 = ["onChange"]

import { getEntityTranslation } from "@/helpers";
import { IMultiLevelSelectOption, ISelectOption } from "@hakosalo/hakolib";
import { computed, onMounted, Ref, ref } from "vue";
import publicFormApi from "@/publicFormApi";
import { ClassificationInformationSingleLevelBaseDto } from "@api/classification-information-single-level-base-dto";
import { Field } from "@/types/interfaces/field";

type OptionType = any & {
	id: number | null;
	parentId?: number | null;
	children?: any[];
	enabled: boolean;
	translations: Array<{ languageCode: string }> | null;
};

type OptionsType = Array<OptionType>;

interface Props {
	field?: Field;
	valueSingle?: OptionType | null;
	valueSingleId?: number | null;
	valueMulti?: OptionType[];
	infoTable: string;
	translationsTable: string;
	translationProperty: string;
	isInvalid?: boolean | null;
	tree?: boolean;
	ajax?: boolean;
	optionFilter?: (option: OptionType) => boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ClassificationInformationsSelect',
  props: {
    field: {},
    valueSingle: {},
    valueSingleId: {},
    valueMulti: {},
    infoTable: {},
    translationsTable: {},
    translationProperty: { default: "name" },
    isInvalid: { type: [Boolean, null], default: null },
    tree: { type: Boolean, default: false },
    ajax: { type: Boolean, default: false },
    optionFilter: {}
  },
  emits: [
	"update:valueSingle",
	"update:valueSingleId",
	"update:valueMulti",
	"blur",
],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

// type OptionType = T & {
// 	id: number | null;
// 	parentId?: number | null;
// 	children?: T[];
// 	enabled: boolean;
// 	translations: Array<{ languageCode: string }> | null;
// };
const props = __props;

// I dont know why this is needed
const cField = computed(() => {
	return props.field;
});

const options = ref<OptionsType>([]) as Ref<OptionsType>;

const cValueSingle = computed({
	get() {
		return props.valueSingle as OptionType;
	},
	set(newVal: OptionType) {
		emit("update:valueSingleId", newVal?.id || null);
		emit("update:valueSingle", newVal);
	},
});

const cValueMulti = computed({
	get() {
		return props.valueMulti as OptionType[];
	},
	set(newVal: OptionType[]) {
		emit("update:valueMulti", newVal);
	},
});

// internal use only
// const _cAllValues = computed(
// 	() => [...(cValueMulti.value || []), cValueSingle.value].filter((r) => !!r) as OptionType[]
// );

// const removeSelection = (option: ISelectOption<OptionType>) => {
// 	const index = cValueMulti.value.findIndex((o) => o.id === option.value.id);
// 	if (index > -1) {
// 		cValueMulti.value.splice(index, 1);
// 	}
// };

const fnValueToOption = (val: OptionType) => {
	if (!val) {
		return null;
	}
	return {
		text: getEntityTranslation(val.translations, props.translationProperty),
		value: val,
	} as ISelectOption<OptionType>;
};

// const cOptions = computed(() => {
// 	if (props.tree) {
// 		return [];
// 	}
// 	const selectedVals = _cAllValues.value
// 		.filter((r) => !!r)
// 		.map((o: OptionType) => fnValueToOption(o)) as ISelectOption<OptionType>[];

// 	const opts = options.value
// 		.filter((r) => !!r)
// 		.map((o: OptionType) => fnValueToOption(o)) as ISelectOption<OptionType>[];

// 	const combinedOptions = [...selectedVals, ...opts];

// 	return uniqBy(combinedOptions, (r) => r.value.id);
// });

const mapToMultiLevelSelectOption = (options: OptionType[]) => {
	return options.map((item) => {
		const option = {
			key: item.id,
			obj: item,
			value: item.id,
			text: getEntityTranslation(item.translations, props.translationProperty),
			disabled: false,
			children: [] as IMultiLevelSelectOption<OptionType>[],
		} as IMultiLevelSelectOption<OptionType>;

		if (Array.isArray(item.children) && item.children.length > 0) {
			option.children = mapToMultiLevelSelectOption(item.children as OptionType[]);
		}
		return option;
	});
};

const cSelectedItems = computed({
	get() {
		return cValueMulti.value.map((item) => {
			return {
				key: item.id,
				obj: item,
				value: item.id,
				text: getEntityTranslation(item.translations, props.translationProperty),
				disabled: false,
				children: [] as IMultiLevelSelectOption<OptionType>[],
			} as IMultiLevelSelectOption<OptionType>;
		});
	},
	set(val: IMultiLevelSelectOption<OptionType>[]) {
		emit(
			"update:valueMulti",
			val.map((x) => x.obj)
		);
	},
});

const showTreeWindow = ref(false);

const removeTreeSelection = (option: IMultiLevelSelectOption<OptionType>) => {
	cValueMulti.value = cValueMulti.value.filter((o) => o.id !== option.obj.id);
};

const cTreeOptions = computed(() => {
	if (!props.tree) {
		return [];
	}
	return mapToMultiLevelSelectOption(options.value);
});

// const selectedMultiValueAsOptions = computed(() => {
// 	if (!props.valueMulti) {
// 		return [];
// 	}
// 	return props.valueMulti
// 		.map((o: OptionType) => fnValueToOption(o))
// 		.filter((r) => !!r) as ISelectOption<OptionType>[];
// });

const getOptions = (search?: string) => {
	publicFormApi.call.form.get
		.getClassificationInformationsSingleLevel<OptionType>(
			props.infoTable,
			props.translationsTable,
			[props.translationProperty],
			search
		)
		.then((res) => {
			if (res.data) {
				options.value = res.data as unknown as OptionsType;
				if (props.optionFilter) {
					options.value = options.value.filter(props.optionFilter);
				}
			}
		});
};

const loadOptions = async (search?: string, page?: number) => {
	const data =
		await publicFormApi.call.form.get.getClassificationInformationsSingleLevel<OptionType>(
			props.infoTable,
			props.translationsTable,
			[props.translationProperty],
			search
		);
	if (data && data.data) {
		return data.data as unknown as OptionsType[];
	}

	return [] as OptionsType[];
};

onMounted(() => {
	if (!props.ajax) {
		getOptions();
	}
});

return (_ctx: any,_cache: any) => {
  const _component_HakoSingleSelect2 = _resolveComponent("HakoSingleSelect2")!
  const _component_HakoMultiselect2 = _resolveComponent("HakoMultiselect2")!
  const _component_HakoButton = _resolveComponent("HakoButton")!
  const _component_HakoMultiLevelSelect = _resolveComponent("HakoMultiLevelSelect")!
  const _component_HakoWindow = _resolveComponent("HakoWindow")!

  return (_openBlock(), _createElementBlock("div", null, [
    (cValueSingle.value !== undefined)
      ? (_openBlock(), _createBlock(_component_HakoSingleSelect2, {
          key: 0,
          modelValue: cValueSingle.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cValueSingle).value = $event)),
          useAjax: _ctx.ajax,
          onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('blur'))),
          isInvalid: _ctx.isInvalid,
          optionGenerator: fnValueToOption,
          optionComparer: (r) => r.id,
          optionLoader: loadOptions,
          useWindowMenu: ""
        }, null, 8, ["modelValue", "useAjax", "isInvalid", "optionComparer"]))
      : _createCommentVNode("", true),
    (!_ctx.tree)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (cValueMulti.value !== undefined)
            ? (_openBlock(), _createBlock(_component_HakoMultiselect2, {
                key: 0,
                modelValue: cValueMulti.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((cValueMulti).value = $event)),
                useAjax: _ctx.ajax,
                onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('blur'))),
                isInvalid: _ctx.isInvalid,
                optionGenerator: fnValueToOption,
                optionComparer: (r) => r.id,
                optionLoader: loadOptions,
                useWindowMenu: ""
              }, null, 8, ["modelValue", "useAjax", "isInvalid", "optionComparer"]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_HakoButton, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (showTreeWindow.value = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("generic.changeSelections")), 1)
              ]),
              _: 1
            })
          ], 512),
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cSelectedItems.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.value
              }, [
                _createElementVNode("input", {
                  type: "checkbox",
                  checked: "",
                  onChange: ($event: any) => (removeTreeSelection(item))
                }, null, 40, _hoisted_3),
                _createTextVNode(" " + _toDisplayString(item.text), 1)
              ]))
            }), 128))
          ]),
          _createVNode(_component_HakoWindow, {
            modelValue: showTreeWindow.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showTreeWindow).value = $event)),
            title: (cField.value && _unref(getEntityTranslation)(cField.value.translations, 'name')) || '',
            "position-under-element": (_ctx.$refs.showbtn as HTMLElement),
            size: "m",
            style: {"z-index":"9999"}
          }, {
            default: _withCtx(() => [
              (cValueMulti.value !== undefined && _ctx.tree && showTreeWindow.value)
                ? (_openBlock(), _createBlock(_component_HakoMultiLevelSelect, {
                    key: 0,
                    title: (cField.value && _unref(getEntityTranslation)(cField.value.translations, 'name')) || '',
                    items: cTreeOptions.value,
                    modelValue: cSelectedItems.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((cSelectedItems).value = $event)),
                    onSave: _cache[6] || (_cache[6] = ($event: any) => (showTreeWindow.value = false)),
                    onCancel: _cache[7] || (_cache[7] = ($event: any) => (showTreeWindow.value = false))
                  }, null, 8, ["title", "items", "modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "title", "position-under-element"])
        ], 64))
  ]))
}
}

})